import { autoCapitalize } from '@/utils/autoCapitalize'
import { ProfessionalData } from './ProfessionalByPatientName.types'

class ProfessionalByPatientNameMapper {
  toDomain(persistenceUserManagementData: ProfessionalData) {
    return {
      key: persistenceUserManagementData?.id,
      value: autoCapitalize(persistenceUserManagementData?.nome),
    }
  }
}

export default new ProfessionalByPatientNameMapper()
